import { ACTIVITY_GROUP_REQUEST, ACTIVITY_GROUP_SHOW, ACTIVITY_GROUP_FAIL } from "../store/config";

const activityGroupInit = {
	isFetching:false,
	list:[],
	error: undefined,
	timestamp: undefined
};

const activityGroup = (state=activityGroupInit,action) => {
	switch (action.type){
		case ACTIVITY_GROUP_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			};
		case ACTIVITY_GROUP_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			};
		case ACTIVITY_GROUP_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			};
		default:
			return {
				...state
			}
	}
};

export default activityGroup;


// WEBPACK FOOTER //
// ./src/reducers/activity_groups.js